// extracted by mini-css-extract-plugin
export default {"conversation-list-header":"conversation-list-header__Myu2Ime_Ujjt"};